export const messages = {
  en: {
    payFeeOrder: {
      title: 'Order Payment',
      back: 'Back',
      feeId: 'Fee ID:',
      feeName: 'Fee Item:',
      feeType: 'Fee Type:',
      billingStartTime: 'Billing Start Time:',
      area: 'Area:',
      unitPrice: 'Unit Price:',
      additionalFee: 'Additional Fee:',
      fixedFee: 'Fixed Fee:',
      ownerAccount: 'Owner Account:',
      giftPoints: 'Gift Points:',
      receivable: 'Receivable:',
      amountPayable: 'Amount Payable:',
      paymentTime: 'Payment Time:',
      paymentTimePlaceholder: 'Required, please fill in the payment time',
      paymentCycle: 'Payment Cycle:',
      selectPaymentCycle: 'Please select payment cycle',
      month: 'months',
      customCycle: 'Custom Cycle',
      customAmount: 'Custom Amount',
      customEndTime: 'Custom End Time',
      customTimeRange: 'Custom Time Range',
      actualCycle: 'Actual Cycle:',
      inputActualCycle: 'Please enter actual cycle',
      endTime: 'End Time:',
      selectEndTime: 'Please select payment end time',
      paymentPeriod: 'Payment Period:',
      selectStartTime: 'Please select payment start time',
      paymentMethod: 'Payment Method:',
      selectPaymentMethod: 'Required, please select payment method',
      actualReceipt: 'Actual Receipt:',
      inputActualAmount: 'Please enter actual receipt amount',
      remark: 'Remark:',
      inputRemark: 'Optional, please fill in the remark',
      scanPayment: 'Scan Payment',
      submitPayment: 'Submit Payment'
    },
    viewRoomData: {
      details: 'Details',
      label: 'Item',
      value: 'Value',
      room: 'Room',
      floor: 'Floor',
      owner: 'Owner',
      phone: 'Phone',
      type: 'Type',
      builtUpArea: 'Built-up Area',
      roomArea: 'Room Area',
      rent: 'Rent',
      state: 'State',
      moveInTime: 'Move-in Time'
    },
    viewFeeData: {
      details: 'Details',
      label: 'Item',
      value: 'Value',
      feeId: 'Fee ID',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      payerObj: 'Payer Object',
      feeName: 'Fee Name',
      state: 'State',
      createTime: 'Create Time',
      billingStartTime: 'Billing Start Time',
      billingEndTime: 'Billing End Time',
      batch: 'Batch'
    },
    viewFeeConfigData: {
      feeItem: 'Fee Item',
      label: 'Item',
      value: 'Value',
      configId: 'Config ID',
      feeType: 'Fee Type',
      feeName: 'Fee Name',
      feeFlag: 'Fee Flag',
      billType: 'Bill Type',
      paymentType: 'Payment Type',
      prepay: 'Prepay',
      postpay: 'Postpay',
      paymentCycle: 'Payment Cycle',
      billingStartTime: 'Billing Start Time',
      billingEndTime: 'Billing End Time',
      formula: 'Formula',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional/Fixed Fee'
    },
    payFeeUserAccount: {
      title: 'Account Information',
      accountInfo: 'Account Information',
      refresh: 'Refresh',
      select: 'Select',
      accountType: 'Account Type',
      accountName: 'Account Name',
      accountAmount: 'Account Amount',
      operation: 'Operation',
      yuan: 'yuan',
      prestore: 'Prestore'
    },
    payFeeOrderResult: {
      title: 'Payment Prompt',
      success: 'Payment successful',
      receiptTip: 'Please go to the business acceptance page to reprint the receipt',
      back: 'Back',
      printSmall: 'Print Small Ticket',
      mergePrint: 'Merge Print',
      printReceipt: 'Print Receipt'
    },
    payFeeOrderConfirm: {
      title: 'Payment Confirmation',
      payerObj: 'Payer Object:',
      timeRange: 'Payment Period:',
      receivable: 'Receivable Amount:',
      discountAmount: 'Discount Amount:',
      discountTooltip: 'Positive: discounted amount; Negative: additional late fee',
      actualAmount: 'Actual Receipt:',
      deductionAmount: 'Deduction Amount:',
      amountPayable: 'Amount Payable:',
      integralDeduction: 'Integral Account Deduction:',
      cashDeduction: 'Cash Account Deduction:',
      remark: 'Remark:',
      authCode: 'Auth Code:',
      authCodePlaceholder: 'Please scan with scanner',
      close: 'Close',
      confirm: 'Confirm Payment'
    },
    payFeeDiscount: {
      title: 'Discount Information',
      discountInfo: 'Discount Information',
      discountType: 'Discount Type',
      discountName: 'Discount Name',
      ruleName: 'Rule Name',
      rule: 'Rule',
      discountAmount: 'Discount Amount',
      discountTooltip: 'Negative: discounted amount; Positive: additional late fee',
      yuan: 'yuan',
      discount: 'Discount',
      penalty: 'Penalty',
      specialDiscount: 'Special Discount',
      monthSpec: 'Month',
      penaltySpec: 'Penalty'
    },
    payFeeCoupon: {
      title: 'Gift Coupon',
      couponInfo: 'Gift Coupon Information',
      ruleName: 'Rule Name',
      couponName: 'Coupon Name',
      quantity: 'Quantity',
      unit: 'pcs',
      purpose: 'Purpose'
    },
    prestoreAccount2: {
      title: 'Prestore',
      receivable: 'Receivable:',
      actualReceipt: 'Actual Receipt:',
      prestoreAmount: 'Prestore Amount:',
      amountPlaceholder: 'Required, please fill in the prestore amount',
      remark: 'Remark:',
      remarkPlaceholder: 'Optional, please fill in the remark',
      cancel: 'Cancel',
      save: 'Save',
      amountRequired: 'Amount cannot be empty',
      amountFormat: 'Amount format error',
      remarkMaxLength: 'Remark cannot exceed 200 characters',
      saveSuccess: 'Prestore successfully',
      saveError: 'Prestore failed'
    }
  },
  zh: {
    payFeeOrder: {
      title: '订单收费',
      back: '返回',
      feeId: '费用ID:',
      feeName: '费用项目:',
      feeType: '费用类型:',
      billingStartTime: '计费起始时间:',
      area: '面积:',
      unitPrice: '单价:',
      additionalFee: '附加费:',
      fixedFee: '固定费:',
      ownerAccount: '业主账户:',
      giftPoints: '赠送积分:',
      receivable: '应收款:',
      amountPayable: '应缴金额:',
      paymentTime: '缴费时间:',
      paymentTimePlaceholder: '必填，请填写缴费时间',
      paymentCycle: '缴费周期:',
      selectPaymentCycle: '请选择缴费周期',
      month: '个月',
      customCycle: '自定义周期',
      customAmount: '自定义金额',
      customEndTime: '自定义结束时间',
      customTimeRange: '自定义时间段',
      actualCycle: '实际周期:',
      inputActualCycle: '请输入实际周期',
      endTime: '结束时间:',
      selectEndTime: '请选择缴费结束时间',
      paymentPeriod: '缴费时间段:',
      selectStartTime: '请选择缴费开始时间',
      paymentMethod: '支付方式:',
      selectPaymentMethod: '必填，请选择支付方式',
      actualReceipt: '实收款:',
      inputActualAmount: '请输入实际收款金额',
      remark: '备注:',
      inputRemark: '可填，请填写备注',
      scanPayment: '扫码收费',
      submitPayment: '提交收费'
    },
    viewRoomData: {
      details: '详情',
      label: '项目',
      value: '值',
      room: '房屋',
      floor: '楼层',
      owner: '业主',
      phone: '电话',
      type: '类型',
      builtUpArea: '建筑面积',
      roomArea: '室内面积',
      rent: '租金',
      state: '房屋状态',
      moveInTime: '入住时间'
    },
    viewFeeData: {
      details: '详情',
      label: '项目',
      value: '值',
      feeId: '费用ID',
      feeFlag: '费用标识',
      feeType: '费用类型',
      payerObj: '付费对象',
      feeName: '费用项',
      state: '费用状态',
      createTime: '建账时间',
      billingStartTime: '计费开始时间',
      billingEndTime: '计费结束时间',
      batch: '批次'
    },
    viewFeeConfigData: {
      feeItem: '费用项',
      label: '项目',
      value: '值',
      configId: '费用项ID',
      feeType: '费用类型',
      feeName: '收费项目',
      feeFlag: '费用标识',
      billType: '催缴类型',
      paymentType: '付费类型',
      prepay: '预付费',
      postpay: '后付费',
      paymentCycle: '缴费周期',
      billingStartTime: '计费起始时间',
      billingEndTime: '计费终止时间',
      formula: '公式',
      unitPrice: '计费单价',
      additionalFee: '附加/固定费用'
    },
    payFeeUserAccount: {
      title: '账户信息',
      accountInfo: '账户信息',
      refresh: '刷新',
      select: '选择',
      accountType: '账户类型',
      accountName: '账户名',
      accountAmount: '账户金额',
      operation: '操作',
      yuan: '元',
      prestore: '预存'
    },
    payFeeOrderResult: {
      title: '缴费提示',
      success: '缴费成功',
      receiptTip: '请到业务受理页面补打收据',
      back: '返回',
      printSmall: '打印小票',
      mergePrint: '合并打印',
      printReceipt: '打印收据'
    },
    payFeeOrderConfirm: {
      title: '收费确认',
      payerObj: '付费对象：',
      timeRange: '缴费时间段：',
      receivable: '应收金额：',
      discountAmount: '优惠金额：',
      discountTooltip: '正数：打折减免的金额；负数：需额外缴纳的滞纳金',
      actualAmount: '实收金额：',
      deductionAmount: '抵扣金额：',
      amountPayable: '应缴金额：',
      integralDeduction: '积分账户抵扣金额：',
      cashDeduction: '现金账户抵扣金额：',
      remark: '备注：',
      authCode: '授权码：',
      authCodePlaceholder: '请用扫码枪扫码',
      close: '关闭',
      confirm: '确定收费'
    },
    payFeeDiscount: {
      title: '折扣信息',
      discountInfo: '折扣信息',
      discountType: '折扣类型',
      discountName: '折扣名称',
      ruleName: '规则名称',
      rule: '规则',
      discountAmount: '折扣金额',
      discountTooltip: '负数：打折减免的金额；正数：需额外缴纳的滞纳金',
      yuan: '元',
      discount: '优惠',
      penalty: '违约',
      specialDiscount: '优惠(需要申请)',
      monthSpec: '月份',
      penaltySpec: '滞纳金'
    },
    payFeeCoupon: {
      title: '赠送优惠券',
      couponInfo: '赠送优惠券',
      ruleName: '赠送规则',
      couponName: '优惠券名称',
      quantity: '数量',
      unit: '张',
      purpose: '用途'
    },
    prestoreAccount2: {
      title: '预存',
      receivable: '应收：',
      actualReceipt: '实收：',
      prestoreAmount: '预存金额：',
      amountPlaceholder: '必填，请填写预存金额',
      remark: '备注：',
      remarkPlaceholder: '可填，请填写备注',
      cancel: '取消',
      save: '保存',
      amountRequired: '金额不能为空',
      amountFormat: '金额格式错误',
      remarkMaxLength: '备注长度不能超过200位',
      saveSuccess: '预存成功',
      saveError: '预存失败'
    }
  }
}